module.exports = __webpack_public_path__ + "img/aetosky-logo-white.bbec9a5d.png";